import { forwardRef } from 'react';

import type { CountryProps } from '@app/components/Phone/types';
import { Flag } from '@app/components/Phone/ui';

import '@app/components/Phone/styles/Country.desktop.scss';
const PF = 'country';

export const Country = forwardRef<HTMLDivElement, CountryProps>(
  ({ onClick, countryAlpha2 }, ref) => (
    <div
      ref={ref}
      className={`${PF}_container`}
      onClick={onClick}
      data-testid="country-code-dropdown"
    >
      <Flag countryAlpha2={countryAlpha2} />
    </div>
  )
);

Country.displayName = 'Country';
